import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PubSubEvents } from '../models/add-to-trolley-pub-sub-event';

/**
 * Publisher/Subscriber Service
 */
@Injectable({
	providedIn: 'root',
})
export class PubSubService {
	events: any = {};
	eventName: PubSubEvents;

	/**
	 * Subscribes the instance of the assigned event name
	 * @param eventName
	 * Event name of the delegate
	 */
	// eslint-disable-next-line @typescript-eslint/naming-convention
	public On(eventName: PubSubEvents): Observable<any> {
		this.eventName = eventName;
		if (typeof this.events[eventName] === 'undefined') {
			this.events[eventName] = new Subject<any>();
		}
		return this.events[eventName].asObservable();
	}

	/**
	 * Broadcast data to the specified event channel
	 * @param eventName
	 * Event name of the delegate
	 * @param eventArgs
	 * Arguments to pass through the connected channel
	 */
	// eslint-disable-next-line @typescript-eslint/naming-convention
	public Broadcast(eventName: PubSubEvents, eventArgs: any): void {
		this.eventName = eventName;
		if (!this.events[eventName]) {
			return;
		}
		this.events[eventName].next(eventArgs);
	}
}
